// src/hooks/klines/adapters/ourbitFutures.js

const DEFAULT_PROXY = `${process.env.REACT_APP_BACKEND_URL}/proxy`;

const INTERVAL_MAP = {
  "1m": "Min1",
  "3m": "Min3",
  "5m": "Min5",
  "15m": "Min15",
  "30m": "Min30",
  "1h": "Hour1",
  "2h": "Hour2",
  "4h": "Hour4",
  "6h": "Hour6",
  "8h": "Hour8",
  "12h": "Hour12",
  "1d": "Day1",
  "1w": "Week1",
  "1M": "Month1",
};

function toOurbitSymbol(input) {
  const s = String(input || "").toUpperCase().replace(/[-]/g, "_");
  if (!s) return null;
  if (/_USDT$/.test(s)) return s;
  const m = s.match(/^([A-Z0-9]+)USDT$/);
  if (m) return `${m[1]}_USDT`;
  return `${s}_USDT`;
}
function toOurbitInterval(tf) { return INTERVAL_MAP[tf] || "Min1"; }
function futUrl(sym, endSec, intervalKey) {
  return `https://futures.ourbit.com/api/v1/contract/kline/${sym}/recent?end=${endSec}&interval=${intervalKey}`;
}

// === ВАЖНО: нормализуем под {time, open, high, low, close, volume} ===
function normalizeKlines(json) {
  const ok = json?.success === true || json?.code === 0;
  const d  = json?.data || {};
  const T  = Array.isArray(d.time) ? d.time : [];

  if (!ok || T.length === 0) return [];

  // Берём real* если есть, иначе обычные
  const O = d.realOpen  ?? d.open  ?? [];
  const H = d.realHigh  ?? d.high  ?? [];
  const L = d.realLow   ?? d.low   ?? [];
  const C = d.realClose ?? d.close ?? [];
  const V = d.vol ?? d.Volume ?? d.volume ?? d.amount ?? [];

  const n = T.length;
  const out = [];
  for (let i = 0; i < n; i++) {
    const time   = Number(T[i]) * 1000; // сек → мс
    const open   = Number(O[i]);
    const high   = Number(H[i]);
    const low    = Number(L[i]);
    const close  = Number(C[i]);
    const volume = Number(V[i]);

    // фильтр странных/пустых значений
    if ([time, open, high, low, close].every(Number.isFinite)) {
      out.push({ time, open, high, low, close, volume });
    }
  }
  return out;
}

export async function ourbitFuturesFetchHistory({
  symbol,
  interval = "1m",
  limit = 300,
  endSec,
  proxy = DEFAULT_PROXY,
} = {}) {
  const sym = toOurbitSymbol(symbol);
  if (!sym) throw new Error("ourbitFutures: bad symbol");

  const intervalKey = toOurbitInterval(interval);
  const end = typeof endSec === "function" ? endSec() : (endSec ?? Math.floor(Date.now() / 1000));

  const url = futUrl(sym, end, intervalKey);
  const finalUrl = proxy ? `${proxy}/${url}` : url;

  // Для дебага в консоли
  console.log("[OURBIT FUTURES KLINES] URL:", finalUrl);

  // const r = await fetch(finalUrl);
  const r = await fetch(finalUrl, {
    headers: {
      'ngrok-skip-browser-warning': 'true',
    },
  });
  if (!r.ok) throw new Error(`ourbitFutures: HTTP ${r.status}`);
  const js = await r.json();

  const arr = normalizeKlines(js);
  console.log("[OURBIT FUTURES KLINES] candles:", arr.length);

  return Array.isArray(arr) && limit > 0 ? arr.slice(-limit) : arr;
}

export const ourbitFuturesUtils = { toOurbitSymbol, toOurbitInterval, INTERVAL_MAP };
